/* Librería UADY — comportamiento del tema (v1.4). Sin dependencias.
   Todo tiene respaldo sin JavaScript: formularios normales, enlaces y páginas completas. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var T = window.theme || { routes: {}, strings: {} };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 3200);
  }
  function overlay(show, onClose) {
    var el = $('.overlay');
    if (show) {
      if (!el) { el = document.createElement('div'); el.className = 'overlay'; document.body.appendChild(el); }
      el.onclick = onClose; document.body.style.overflow = 'hidden';
    } else { if (el) el.remove(); document.body.style.overflow = ''; }
  }
  function renderSection(url, id) {
    return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id).then(function (r) { if (!r.ok) throw r; return r.text(); });
  }
  function parse(html) { var d = document.createElement('div'); d.innerHTML = html; return d; }

  /* ---------- Megamenú ---------- */
  function closeMegas(except) {
    $$('[data-mega-toggle]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var m = document.getElementById(b.getAttribute('aria-controls')); if (m) m.hidden = true;
    });
  }
  $$('[data-mega-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeMegas(btn);
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var m = document.getElementById(btn.getAttribute('aria-controls')); if (m) m.hidden = open;
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.mega')) closeMegas();
    if (!e.target.closest('.header__search')) closePredictive();
  });

  /* ---------- Menú móvil ---------- */
  var nav = $('[data-nav]'), navOpen = $('[data-menu-open]');
  function closeNav() {
    if (!nav || !nav.classList.contains('is-open')) return;
    nav.classList.remove('is-open'); document.body.style.overflow = '';
    if (navOpen) { navOpen.setAttribute('aria-expanded', 'false'); navOpen.focus(); }
  }
  if (nav && navOpen) {
    navOpen.addEventListener('click', function () {
      nav.classList.add('is-open'); navOpen.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden';
      var f = $('.nav__link', nav); if (f) f.focus();
    });
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeNav); });
  }

  /* ---------- Filtros ---------- */
  var facets = $('[data-facets-form]');
  function closeFacets() { if (facets && facets.classList.contains('is-open')) { facets.classList.remove('is-open'); overlay(false); } }
  $$('[data-facets-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!facets) return; facets.classList.add('is-open'); overlay(true, closeFacets);
      var f = $('summary', facets); if (f) f.focus();
    });
  });
  $$('[data-facets-close]').forEach(function (b) { b.addEventListener('click', closeFacets); });
  if (facets) {
    var desktop = window.matchMedia('(min-width: 990px)');
    facets.addEventListener('change', function (e) {
      if (e.target.type === 'number') return;
      if (desktop.matches) { facets.requestSubmit ? facets.requestSubmit() : facets.submit(); }
    });
    facets.addEventListener('submit', function () {
      $$('input[type="number"]', facets).forEach(function (i) { if (i.value === '') i.disabled = true; });
    });
  }
  $$('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- Ficha: cantidad, miniaturas, compartir, barra fija ---------- */
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
    });
  });
  var coverImg = $('[data-cover] img');
  $$('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!coverImg) return;
      coverImg.removeAttribute('srcset'); coverImg.src = b.dataset.thumb;
      $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    });
  });
  $$('[data-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      var data = { title: b.dataset.title, url: b.dataset.url };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).then(function () { toast(T.strings.copied); }).catch(function () { window.prompt('', data.url); });
      }
    });
  });
  var sticky = $('[data-sticky-buy]'), mainBuy = $('[data-main-buy]');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; });
    }).observe(mainBuy);
  }

  /* ---------- Avísame cuando llegue ---------- */
  (function () {
    var n = $('[data-notify]');
    if (n && /contact_posted=true|form_type=contact/.test(window.location.search + window.location.hash)) { n.hidden = false; n.scrollIntoView({ block: 'center' }); }
  })();

  /* ---------- Formatos (variantes) ---------- */
  $$('[data-formats]').forEach(function (box) {
    box.addEventListener('change', function (e) {
      var r = e.target.closest('[data-variant-radio]'); if (!r) return;
      $$('.format', box).forEach(function (l) { l.classList.toggle('is-current', l.contains(r)); });
      var idInput = $('[data-variant-id]'); if (idInput) idInput.value = r.value;
      var pb = $('[data-price-box] .price__current') || $('[data-price-box] .price__free');
      if (pb) pb.textContent = r.dataset.price;
      var cmp = $('[data-price-box] .price__compare'); if (cmp) { cmp.textContent = r.dataset.compare; cmp.hidden = !r.dataset.compare; }
      var note = $('[data-format-note]'); if (note) { note.textContent = r.dataset.note; note.hidden = !r.dataset.note; }
      var buy = $('[data-main-buy]');
      if (buy && buy.tagName === 'BUTTON') buy.disabled = r.dataset.available !== 'true';
      var notify = $('[data-notify]');
      if (notify) {
        notify.hidden = r.dataset.available === 'true';
        var np = $('[data-notify-product]', notify), lab = r.closest('.format');
        var vn = lab ? $('strong', lab) : null;
        if (np) np.value = np.dataset.base + (vn && box.querySelectorAll('[data-variant-radio]').length > 1 ? ' — ' + vn.textContent.trim() : '');
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', r.value);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* ---------- Carrito ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }
  function drawerEl() { return $('[data-cart-drawer]'); }
  function openDrawer() {
    var d = drawerEl(); if (!d) return false;
    d.hidden = false; document.body.style.overflow = 'hidden';
    var c = $('[data-drawer-close]', d); if (c) c.focus();
    return true;
  }
  function closeDrawer() { var d = drawerEl(); if (d && !d.hidden) { d.hidden = true; document.body.style.overflow = ''; } }
  function refreshDrawer(html) {
    var d = drawerEl(); if (!d) return;
    var fresh = parse(html).querySelector('[data-cart-drawer]');
    if (fresh) { d.innerHTML = fresh.innerHTML; }
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open && T.cartType === 'drawer' && drawerEl()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    var d = drawerEl();
    if (d && !d.hidden && e.target === d) closeDrawer();
    var line = e.target.closest('[data-line]');
    if (line && d && d.contains(line)) {
      d.classList.add('is-loading');
      fetch(T.routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: parseInt(line.dataset.lineQty, 10), sections: ['cart-drawer'] })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        updateCount(cart.item_count);
        if (cart.sections && cart.sections['cart-drawer']) refreshDrawer(cart.sections['cart-drawer']);
      }).catch(function () { toast(T.strings.error); }).finally(function () { d.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('click', function (e) {
    var d = drawerEl();
    if (d && !d.hidden && e.target.classList && e.target.classList.contains('drawer')) closeDrawer();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]') || document.querySelector('[form="' + form.id + '"]');
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    if (drawerEl()) fd.append('sections', 'cart-drawer');
    fetch(T.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        if (item.sections && item.sections['cart-drawer']) refreshDrawer(item.sections['cart-drawer']);
        return fetch(T.routes.cart_url + '.js').then(function (c) { return c.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (!(T.cartType === 'drawer' && openDrawer())) toast(T.strings.added);
      })
      .catch(function (err) { toast((err && err.description) || T.strings.error); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Búsqueda predictiva ---------- */
  var psForm = $('.search-field[data-predictive="true"]');
  var psBox = psForm && $('[data-predictive-box]', psForm);
  var psInput = psForm && $('input[type="search"]', psForm);
  var psTimer, psLast = '';
  function closePredictive() { if (psBox && !psBox.hidden) { psBox.hidden = true; psInput.setAttribute('aria-expanded', 'false'); } }
  if (psForm && psBox && psInput && T.routes.predictive_search_url) {
    psInput.addEventListener('input', function () {
      var q = psInput.value.trim();
      clearTimeout(psTimer);
      if (q.length < 2) { closePredictive(); return; }
      psTimer = setTimeout(function () {
        if (q === psLast) { psBox.hidden = false; return; }
        psLast = q;
        var url = T.routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,vendor,tag,variants.barcode,variants.sku&section_id=predictive-search';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var res = parse(html).querySelector('[data-predictive-results]');
          psBox.innerHTML = res ? res.innerHTML : '';
          psBox.hidden = !psBox.innerHTML.trim();
          psInput.setAttribute('aria-expanded', psBox.hidden ? 'false' : 'true');
        }).catch(function () {});
      }, 220);
    });
    psInput.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && !psBox.hidden) { var a = $('a', psBox); if (a) { e.preventDefault(); a.focus(); } }
    });
    psBox.addEventListener('keydown', function (e) {
      var links = $$('a', psBox), i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (i > 0 ? links[i - 1] : psInput).focus(); }
    });
  }

  /* ---------- Lista de deseos ---------- */
  var WISH = 'uady_wish';
  function syncWish() {
    var list = store.get(WISH);
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wish) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = $('[data-wish-label]', b); if (label) label.textContent = on ? T.strings.wishRemove : T.strings.wishAdd;
    });
    $$('[data-wish-count]').forEach(function (el) { el.textContent = list.length; el.hidden = list.length === 0; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var list = store.get(WISH), h = b.dataset.wish, i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast(T.strings.wishRemove); } else { list.unshift(h); toast(T.strings.wishAdd); }
    store.set(WISH, list.slice(0, 100)); syncWish();
  });
  syncWish();

  function renderCards(handles, target, done) {
    if (!handles.length) { done(0); return; }
    Promise.all(handles.map(function (h) {
      return renderSection('/products/' + encodeURIComponent(h), 'book-card-render').then(function (html) {
        var li = parse(html).querySelector('li'); return li ? li.outerHTML : '';
      }).catch(function () { return ''; });
    })).then(function (parts) {
      target.innerHTML = parts.join(''); syncWish(); done(parts.filter(Boolean).length);
    });
  }
  var wishPage = $('[data-wishlist-page]');
  if (wishPage) {
    renderCards(store.get(WISH), wishPage, function (n) { var em = $('[data-wishlist-empty]'); if (em) em.hidden = n > 0; });
  }

  /* ---------- Vistos recientemente ---------- */
  var rv = $('[data-recently-viewed]');
  if (rv) {
    var current = $('[data-current-handle]');
    var list = store.get('uady_recent').filter(function (h) { return !current || h !== current.dataset.currentHandle; });
    list = list.slice(0, parseInt(rv.dataset.limit, 10) || 8);
    renderCards(list, $('[data-recently-list]', rv), function (n) { rv.hidden = n === 0; });
  }

  /* ---------- Libros relacionados ---------- */
  var rec = $('[data-recommendations]');
  if (rec && rec.dataset.url) {
    fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = parse(html).querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { rec.innerHTML = fresh.innerHTML; syncWish(); } else rec.remove();
    }).catch(function () {});
  }

  /* ---------- Libros de un autor ---------- */
  var ab = $('[data-author-books]');
  if (ab) {
    var byFilter = ab.dataset.url + '?filter.p.m.libro.autores=' + encodeURIComponent(ab.dataset.gid);
    var bySearch = ab.dataset.search + '?type=product&q=' + encodeURIComponent('"' + ab.dataset.name + '"');
    var fill = function (html) {
      var res = parse(html).querySelector('[data-author-results]');
      return res ? { ok: res.dataset.filterOk === 'true', html: res.innerHTML.trim() } : { ok: false, html: '' };
    };
    renderSection(byFilter, 'author-books').then(function (html) {
      var r = fill(html);
      if (r.ok && r.html) { ab.innerHTML = r.html; syncWish(); return; }
      return renderSection(bySearch, 'author-books').then(function (h2) {
        var r2 = fill(h2); ab.innerHTML = r2.html; syncWish();
      });
    }).catch(function () {});
  }

  /* ---------- Directorio A–Z ---------- */
  var az = $('[data-az]'), azList = $('[data-az-list]');
  if (az && azList) {
    var items = $$('li[data-sort]', azList);
    var norm = function (s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase(); };
    var ordenar = function () {
      items.sort(function (a, b) { return norm(a.dataset.sort).localeCompare(norm(b.dataset.sort), 'es'); })
        .forEach(function (li) { azList.appendChild(li); });
    };
    ordenar();
    var azNav = azList.nextElementSibling && azList.nextElementSibling.tagName === 'NAV' ? azList.nextElementSibling : null;
    var azRe = /[?&](page(?:_\d+)?)=(\d+)/, azParam = '', last = 1;
    if (azNav) $$('a[href]', azNav).forEach(function (x) { var m = x.href.match(azRe); if (m) { azParam = m[1]; last = Math.max(last, +m[2]); } });
    if (azNav && azParam && last > 1 && !new URL(location.href).searchParams.has(azParam)) {
      var urls = [];
      for (var pg = 2; pg <= last; pg++) { var u = new URL(location.href); u.searchParams.set(azParam, pg); urls.push(u.toString()); }
      Promise.all(urls.map(function (u) { return fetch(u).then(function (r) { return r.text(); }); })).then(function (pages) {
        pages.forEach(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-az-list].' + (azList.classList[0] || 'author-grid') + ' li[data-sort]').forEach(function (li) { var n = document.importNode(li, true); azList.appendChild(n); items.push(n); });
        });
        azNav.hidden = true; ordenar(); apply();
      }).catch(function () {});
    }
    var letter = '', term = '';
    var apply = function () {
      var shown = 0;
      items.forEach(function (li) {
        var s = norm(li.dataset.sort), n = norm(li.dataset.name);
        var okL = !letter || s.charAt(0) === norm(letter) || (letter === 'Ñ' && (li.dataset.sort || '').toUpperCase().charAt(0) === 'Ñ');
        var okT = !term || n.indexOf(term) > -1 || s.indexOf(term) > -1;
        li.hidden = !(okL && okT); if (!li.hidden) shown++;
      });
      var none = $('[data-az-none]'); if (none) none.hidden = shown > 0;
    };
    $$('[data-az-letter]', az).forEach(function (b) {
      b.addEventListener('click', function () {
        letter = b.dataset.azLetter;
        $$('[data-az-letter]', az).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        apply();
      });
    });
    var sInput = $('[data-az-search]', az);
    if (sInput) sInput.addEventListener('input', function () { term = norm(sInput.value.trim()); apply(); });
  }

  /* ---------- Carrusel de portada ---------- */
  $$('[data-slideshow]').forEach(function (show) {
    var track = $('[data-slideshow-track]', show);
    var slides = $$('[data-slide]', show);
    var dots = $$('[data-slideshow-dot]', show);
    var pauseBtn = $('[data-slideshow-pause]', show);
    if (!track || slides.length < 2) return;
    var index = 0, timer = null, stopped = false, hovering = false;
    var speed = parseInt(show.dataset.speed, 10) || 7000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.matchMedia('(max-width: 749px)');
    var auto = show.dataset.autoplay === 'true' && !reduce;
    function mark(i) {
      index = i;
      slides.forEach(function (s, n) {
        var on = n === i;
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', s).forEach(function (el) { if (!el.classList.contains('slide--book__cover')) el.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (!auto || stopped || hovering || mobile.matches) return;
      timer = setInterval(function () { go(index + 1); }, speed);
    }
    function setPaused(p) {
      stopped = p;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', p ? (T.strings.play || 'Reproducir') : (T.strings.pause || 'Pausar'));
        pauseBtn.innerHTML = p ? T.icons.play : T.icons.pause;
      }
      p ? stop() : start();
    }
    var prev = $('[data-slideshow-prev]', show), next = $('[data-slideshow-next]', show);
    if (prev) prev.addEventListener('click', function () { setPaused(true); go(index - 1); });
    if (next) next.addEventListener('click', function () { setPaused(true); go(index + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { setPaused(true); go(parseInt(d.dataset.slideshowDot, 10)); }); });
    if (pauseBtn) {
      if (!auto) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () { setPaused(!stopped); });
    }
    show.addEventListener('mouseenter', function () { hovering = true; stop(); });
    show.addEventListener('mouseleave', function () { hovering = false; start(); });
    show.addEventListener('focusin', function () { hovering = true; stop(); });
    show.addEventListener('focusout', function (e) { if (!show.contains(e.relatedTarget)) { hovering = false; start(); } });
    show.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { setPaused(true); go(index - 1); }
      if (e.key === 'ArrowRight') { setPaused(true); go(index + 1); }
    });
    var sTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(sTimer);
      sTimer = setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== index && i >= 0 && i < slides.length) mark(i);
      }, 90);
    }, { passive: true });
    track.addEventListener('touchstart', function () { setPaused(true); }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    if (mobile.addEventListener) mobile.addEventListener('change', start);
    mark(0); start();
  });

  /* ---------- Filas de libros con flechas ---------- */
  $$('[data-rail]').forEach(function (rail) {
    var track = $('[data-rail-track]', rail);
    var prev = $('[data-rail-prev]', rail), next = $('[data-rail-next]', rail);
    if (!track || !prev || !next) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max;
    }
    function page(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Boletín: temas de interés como etiquetas ---------- */
  $$('[data-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var field = $('[data-newsletter-tags]', form); if (!field) return;
      var base = (field.defaultValue || 'boletin').split(',')[0];
      var tags = [base];
      $$('[data-interest]:checked', form).forEach(function (c) { if (c.value) tags.push(c.value); });
      field.value = tags.join(',');
    });
  });

  /* ---------- Cómo citar: copiar y descargar RIS / BibTeX ---------- */
  $$('[data-cite]').forEach(function (box) {
    var done = $('[data-cite-done]', box);
    var avisar = function () { if (done) { done.hidden = false; setTimeout(function () { done.hidden = true; }, 2500); } };
    var copy = $('[data-cite-copy]', box);
    if (copy) copy.addEventListener('click', function () {
      var t = $('[data-cite-text]', box); if (!t) return;
      var texto = t.innerText.trim();
      if (navigator.clipboard) navigator.clipboard.writeText(texto).then(avisar); else avisar();
    });
    $$('[data-cite-download]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var tipo = b.dataset.citeDownload;
        var src = $(tipo === 'ris' ? '[data-cite-ris]' : '[data-cite-bib]', box); if (!src) return;
        var blob = new Blob([src.textContent.trim() + '\n'], { type: tipo === 'ris' ? 'application/x-research-info-systems' : 'application/x-bibtex' });
        var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = b.dataset.filename || ('cita.' + tipo);
        document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 500);
      });
    });
  });

  /* ---------- Escape cierra todo ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openBtn = $('[data-mega-toggle][aria-expanded="true"]');
    closeMegas(); if (openBtn) openBtn.focus();
    closeNav(); closeFacets(); closeDrawer();
    if (psBox && !psBox.hidden) { closePredictive(); psInput.focus(); }
  });
})();

(function () {
  var btn = document.querySelector('[data-oa-download]');
  if (!btn) return;
  var hosts = /drive\.google\.com|bit\.ly|dropbox\.com|casaeditorial\.uady\.mx/i;
  document.querySelectorAll('.product .rte a[href]').forEach(function (a) {
    if (!hosts.test(a.href)) return;
    var block = a.closest('p, li, h1, h2, h3, h4, h5, h6, div');
    var resto = block ? block.textContent.replace(a.textContent, '').trim() : '';
    if (block && !block.classList.contains('rte') && resto.length < 90) { block.remove(); return; }
    var prev = a.previousSibling;
    if (prev && prev.nodeType === 3) prev.textContent = prev.textContent.replace(/(Descarga|Consulta|Lee)[^.:]*:?\s*$/i, '');
    a.remove();
  });
})();

(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  var seccion = header.closest('.shopify-section') || header;
  var nav = document.querySelector('[data-nav]');
  // Umbral con histéresis (entra a 120 px, sale a 40 px) y una sola revisión por cuadro.
  // Al bajar, el encabezado se oculta; al subir un poco, vuelve a aparecer.
  // En pantallas táctiles :hover se queda pegado tras tocar; solo cuenta con ratón (menú desplegable).
  var puntero = window.matchMedia('(hover: hover)').matches;
  var marcado = false, oculto = false, pendiente = false, ultimaY = window.scrollY, recorrido = 0;
  function ocupado() {
    var foco = document.activeElement;
    return (nav && nav.classList.contains('is-open')) || (puntero && header.matches(':hover')) ||
      (header.contains(foco) && foco.matches('input, textarea, select, [aria-expanded="true"]'));
  }
  function ocultar(valor) {
    if (valor === oculto) return;
    oculto = valor;
    seccion.classList.toggle('is-hidden', valor);
    document.documentElement.classList.toggle('header-oculto', valor);
  }
  function revisar() {
    pendiente = false;
    var y = Math.max(window.scrollY, 0);
    var ahora = marcado ? y > 40 : y > 120;
    if (ahora !== marcado) { marcado = ahora; header.classList.toggle('is-scrolled', ahora); }
    var delta = y - ultimaY;
    ultimaY = y;
    // Se acumula el recorrido en una misma dirección para no parpadear con desplazamientos mínimos.
    recorrido = (delta > 0) === (recorrido > 0) ? recorrido + delta : delta;
    if (y < seccion.offsetHeight + 40 || ocupado()) { ocultar(false); return; }
    if (recorrido > 24) ocultar(true);
    else if (recorrido < -12) ocultar(false);
  }
  window.addEventListener('scroll', function () {
    if (!pendiente) { pendiente = true; window.requestAnimationFrame(revisar); }
  }, { passive: true });
  // Al navegar con teclado dentro del encabezado, se muestra.
  header.addEventListener('focusin', function () { ocultar(false); });
  revisar();
})();

(function () {
  // Descripciones pegadas de PDF: un salto de línea seguido de minúscula es la misma frase.
  document.querySelectorAll('.product .rte br').forEach(function (br) {
    var sig = br.nextSibling;
    var texto = sig && sig.nodeType === 3 ? sig.textContent.replace(/^\s+/, '') : '';
    if (/^[a-záéíóúñü(«"]/.test(texto)) br.replaceWith(document.createTextNode(' '));
  });
})();

(function () {
  document.querySelectorAll('[data-desc-toggle]').forEach(function (btn) {
    var desc = document.getElementById(btn.getAttribute('aria-controls'));
    if (!desc) return;
    if (desc.scrollHeight <= desc.clientHeight + 4 && desc.scrollWidth <= desc.clientWidth + 4) { btn.hidden = true; desc.classList.add('is-open'); return; }
    btn.addEventListener('click', function () {
      var abierto = desc.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      btn.textContent = abierto ? btn.dataset.less : btn.dataset.more;
    });
  });
})();
